<template>
  <v-menu
    ref="menu1"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="dateFormatted"
        :label="computedLabel"
        hint="DD/MM/YYYY format"
        :placeholder="computedPlaceholder"
        persistent-hint
        prepend-icon="event"
        @blur="date = parseDate(dateFormatted)"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker v-model="date" no-title @input="menu = false" />
  </v-menu>
</template>

<script>
export default {
  name: "DateDropdown",
  props: ["value", "label", "placeholder"],
  computed: {
    computedLabel() {
      return this.label ? this.label : "Date";
    },
    computedPlaceholder() {
      return this.placeholder ? this.placeholder : "Please enter date";
    },
  },
  data() {
    return {
      date: this.value,
      dateFormatted: this.formatDate(this.value),
      menu: false,
    };
  },
  methods: {
    formatDate(date) {
      // console.log(date);
      if (!date) return null;
      const [year, month, day] = date.substring(0, 10).split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
  },
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
      this.$emit("input", this.date);
    },
  },
};
</script>
